var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isProduct)?_c('MainProduct',{attrs:{"brandModel":_vm.allModel},on:{"bannerClick":_vm.bannerClick}}):_c('MainPart')
}
var staticRenderFns = []

export { render, staticRenderFns }